import { render, staticRenderFns } from "./AttachmentsByCategory.vue?vue&type=template&id=6427aed2&scoped=true"
import script from "./AttachmentsByCategory.vue?vue&type=script&lang=js"
export * from "./AttachmentsByCategory.vue?vue&type=script&lang=js"
import style0 from "./AttachmentsByCategory.vue?vue&type=style&index=0&id=6427aed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6427aed2",
  null
  
)

export default component.exports